import { Middleware } from 'redux';
import { ADD_BLOCK, DUPLICATE_BLOCKS } from '../constants/actionTypes/canvasBlocks';

const addBlockCheck: Middleware = ({ getState }) => (next) => (action) => {
    const state = getState();
    const isPikassoPreview = state.session.integration === 'PUBLIC_PREVIEW';
    const isAddBlockAction = action.type === ADD_BLOCK || action.type === DUPLICATE_BLOCKS;
    const maxBlockReached = state.canvasBlocks.present.length >= 40;

    if (isPikassoPreview && isAddBlockAction && maxBlockReached) {
        return;
    }

    return next(action);
};

export default addBlockCheck;
